import React, { FC } from 'react';
import Text from 'Components/Typography/Text';
import { Box } from '@igooods/ui-kit';
import { Flex } from '@igooods/ui-kit';
import styled from 'styled-components';
import MobilePickerImg from './images/picker-mobile.png';
import MobilePickerRetinaImg from './images/picker-mobile@2x.png';
import DesktopPickerImg from './images/picker-desk.png';
import DesktopPickerRetinaImg from './images/picker-desk@2x.png';
import BlockContainer from 'Components/landings/BlockContainer';
import { colors } from 'constants/colors';
import BlockTitle from 'Components/landings/BlockTitle';
import ThemeButton from 'Components/ThemedButton';
import { EnumTheme, EnumButtonSize, EnumGtagEvents } from 'constants/enums';
import { mediaSmDown, mediaSmUp, mediaCustomDown, mediaLgDown } from 'theme/helpers/css';
import { FontSize } from 'theme';
import { IBlockWithButton, GtagFrom, IBlockWithDevice } from 'Components/landings/types';
import analyticsManager from 'utils/tagManager/manager';

const Containter = styled(Flex).attrs({
  column: true,
})`
  position: relative;

  ${mediaSmDown`
    align-items: center;
  `}
`;

const TopBlock = styled.div`
  max-width: 460px;

  ${mediaLgDown`
    max-width: 362px;
  `}

  ${mediaSmDown`
    max-width: none;
    width: 100%;
  `}
`;

const Banner = styled.div`
  position: absolute;
  width: 750px;
  top: 60px;
  right: 0;

  ${mediaCustomDown(1441)`
    width: 635px;
    top: 48px;
  `}

  ${mediaLgDown`
    width: 342px;
  `}

  ${mediaSmDown`
    position: static;
    margin-top: 40px;
    max-width: 342px;
    width: 100%;
  `}

  ${mediaCustomDown(580)`
    margin-top: 28px;
  `}

  img,
  picture {
    width: 100%;
  }
`;

const Description = styled(Text).attrs({
  size: FontSize.m,
})`
  max-width: 395px;
  ${mediaLgDown`
    max-width: 282px;
    font-size: 14px;
    line-height: 22px;
  `}

  ${mediaSmDown`
    max-width: none;
  `}
`;

const Button = styled(ThemeButton)`
  margin-top: 398px;
  width: 210px;
  ${mediaCustomDown(1441)`
    margin-top: 262px;
  `}

  ${mediaLgDown`
    margin-top: 72px;
  `}

  ${mediaSmUp`
    padding: 0 24px 2px;
  `}
  
  ${mediaCustomDown(580)`
    margin-top: 28px;
  `}

  ${mediaSmDown`
    width: 100%;
    margin-top: 38px;
  `}
`;

const PickerBlock: FC<IBlockWithButton & IBlockWithDevice> = ({ onBtnClick, device }) => {
  const handleBtnClick = () => {
    analyticsManager.gtag(EnumGtagEvents.CLICK_CALL_TO_ACTION, {
      from: GtagFrom.PICKER,
      device,
    });

    onBtnClick();
  };

  return (
    <BlockContainer bgColor={colors.algaeGreen}>
      <Containter
        pt={{ xs: 12, sm: 14, lg: 24, xl: 30 }}
        pb={{
          xs: 15,
          sm: 14,
          lg: 24,
          xl: 30,
        }}
      >
        <TopBlock>
          <h2>
            <BlockTitle>Наши пикеры в&nbsp;магазинах&nbsp;&mdash; профи</BlockTitle>
          </h2>
          <Box mt={{ xs: 4.5, sm: 7 }}>
            <Description>
              Пикеры проходят инструктаж и&nbsp;сдают экзамен&nbsp;&mdash; и&nbsp;только после допускаем
              их&nbsp;к&nbsp;работе. Соблюдают наши регламенты сборки, внимательно проверяют срок годности
              и&nbsp;упаковку. А&nbsp;еще согласуют с&nbsp;вами замену, если товар закончился.{' '}
            </Description>
          </Box>
        </TopBlock>
        <Button use={EnumTheme.roundGreen} size={EnumButtonSize.large} onClick={handleBtnClick}>
          Заказать продукты
        </Button>
        <Banner>
          <picture>
            <source media="(max-width: 1279px)" srcSet={`${MobilePickerRetinaImg} 2x, ${MobilePickerImg} 1x`} />
            <source media="(min-width: 1280px)" srcSet={`${DesktopPickerRetinaImg} 2x, ${DesktopPickerImg} 1x`} />
            <img src={DesktopPickerImg} alt="" data-loading="lazy" />
          </picture>
        </Banner>
      </Containter>
    </BlockContainer>
  );
};

export default PickerBlock;
